module.exports = __webpack_public_path__ + "img/verified-list-interface-symbol_azul.fc7a3225.svg";